import React from 'react';
import { PageNotFound } from '../../common/PageNotFound';
import { VerifyEmailPage } from '../views/VerifyEmailPage';

type VerifyEmailControllerProps = {
  page?: 'main';
};

export const VerifyEmailController: React.FC<VerifyEmailControllerProps> = ({ page = 'main' }) => {
  switch (page) {
    case 'main':
      return <VerifyEmailPage />;
    default:
      return <PageNotFound />;
  }
};
